module.exports = __webpack_public_path__ + "img/logo-saml@3x.0fe402a6.png";